import { Component, OnInit,ViewChild ,AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IntlService } from '@progress/kendo-angular-intl';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
//import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ActivatedRoute, Router } from '@angular/router';

import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
declare var $: any;
import {AuthenticationService} from '../authentication.service';

@Component({
  selector: 'app-full-layout',
  providers: [AuthenticationService],
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.css']
})
export class FullLayoutComponent implements OnInit {

  username : any = localStorage.getItem("username");

  userrole : any = localStorage.getItem("userrole");

  dresult;
  sresult;
  lresult;
  presult;

  constructor(private http: Http,private _service:AuthenticationService,private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
  }    

  public getdealerdetail(){
    let url = 'webservice.php?action=getdealer';  
    return this.http.get(url)
      .map(res => res.json())
      .subscribe(response => {    
        this.dresult = response.result;     
      }, //For Success Response  
      err => {
        console.error(err);
        alert('Something Wrong!!');
      } //For Error Response
    );
  }

  public getsalesmandetail(){
    let url = 'webservice.php?action=getsalesman';  
    return this.http.get(url)
      .map(res => res.json())
      .subscribe(response => {    
        this.sresult = response.result;     
      }, //For Success Response  
      err => {
        console.error(err);
        alert('Something Wrong!!');
      } //For Error Response
    );
  }

  public getproduct() {
    let url = 'webservice.php?action=getproduct';  
    return this.http.get(url)
      .map(res => res.json())
      .subscribe(response => {
       // console.log(response)
        this.presult = response.result
      }, //For Success Response  
      err => {
        console.error(err);
        alert('Something Wrong!!');
      } //For Error Response
    );
  }

  public getlotno() {
    let url = 'webservice.php?action=getlotno';  
    return this.http.get(url)
      .map(res => res.json())
      .subscribe(response => {
       // console.log(response)
        this.lresult = response.result
      }, //For Success Response  
      err => {
        console.error(err);
        alert('Something Wrong!!');
      } //For Error Response
    );
  }

}
